import vendor from "fragments/vendors/vendor"
import { gql } from "graphql-tag"

const GET_VENDORS_WAVE = gql`
  ${vendor}

  query getVendorsWave($query: GetWaveQueryVendors) {
    getVendorsWave(query: $query) {
      vendors {
        ...Vendor
      }
      cursor
      hasPrevData
      hasNextData
      prevCursor
    }
  }
`

export default GET_VENDORS_WAVE
